import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  zIndexClass?: string;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, zIndexClass = 'z-50' }) => {
  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 bg-black/70 backdrop-blur-sm flex justify-center items-center p-4 ${zIndexClass}`}
      onClick={onClose}
    >
      <div
        className="bg-surface/95 backdrop-blur-2xl rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-border-strong/40 animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center px-6 py-4 border-b border-border/50 bg-surface-light/40">
          <h2 className="text-lg font-bold text-text-main font-heading">{title}</h2>
          <button 
            onClick={onClose} 
            className="text-text-secondary hover:text-text-main transition-colors text-2xl leading-none p-1 rounded-lg hover:bg-surface-light cursor-pointer"
            aria-label="Schließen"
          >
            &times;
          </button>
        </div>
        <div className="p-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};
